<template>
  <div class="menuManagemen_warp">
    <div v-if="!isAdd && !isEdit && !isDetail" class="menuManagemen">
      <div class="top_content">
        <div class="top_input">
          <el-input placeholder="请输入"></el-input>
        </div>
        <div class="search_btn">查询</div>
        <div class="add_btn" @click="openAdd">添加</div>
      </div>
      <div class="bottom_content">
        <div class="table_container" v-bind:id="tableId">
          <el-table
            :data="tableData"
            style="width: 100%"
            row-key="menuId"
            border
            :default-expand-all="false"
            v-bind:max-height="tableHeight"
            v-bind:header-cell-style="{
              textAlign: 'center',
              color: '#333333',
              background: '#F5F5F5',
            }"
            v-bind:cell-style="{ textAlign: 'center' }"
            empty-text="暂无数据"
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          >
            <el-table-column
              prop="menuId"
              label="菜单编号"
              width="350"
            ></el-table-column>

            <el-table-column prop="menuName" label="菜单名称">
            </el-table-column>
            <!-- <el-table-column
              prop="menuVname"
              label="视图名称"
            ></el-table-column> -->
            <el-table-column prop="menuStatus" label="状态">
              <template #default="scope">
                <span
                  class="lable-status label-primary"
                  v-if="scope.row.menuStatus == 0"
                >
                  正常
                </span>
                <span
                  class="lable-status label-danger"
                  v-if="scope.row.menuStatus == 1"
                >
                  禁用
                </span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="menuIcon" label="未选中图标">
              <template #default="scope">
                <div
                  v-if="scope.row.menuIcon == '' || scope.row.menuIcon == null"
                ></div>
                <div class="menu-icon" v-else>
                  <img :src="scope.row.menuIcon" alt="" />
                </div>
              </template>
            </el-table-column> -->
            <!-- <el-table-column prop="menuSelectIcon" label="选中图标">
              <template #default="scope">
                <div
                  v-if="
                    scope.row.menuSelectIcon == '' ||
                    scope.row.menuSelectIcon == null
                  "
                ></div>
                <div class="menu-icon" style="background: #fff" v-else>
                  <img :src="scope.row.menuSelectIcon" alt="" />
                </div>
              </template>
            </el-table-column> -->
            <el-table-column prop="menuType" label="类型">
              <template #default="scope">
                <span
                  class="lable-status label-success"
                  v-if="scope.row.menuType == 0"
                >
                  目录
                </span>
                <span
                  class="lable-status label-primary"
                  v-if="scope.row.menuType == 1"
                >
                  菜单
                </span>
                <span
                  class="lable-status label-info"
                  v-if="scope.row.menuType == 2"
                >
                  按钮
                </span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="buttonType" label="按钮类型">
              <template #default="scope">
                <div style="display: inline" class="mr-10" v-for="(item, index) in scope.row.buttonType" :key="index">
                  <span
                    class="lable-status label-success"
                    :class="[
                      index == 0
                        ? 'label-primary'
                        : index == 1
                        ? 'label-success'
                        : index == 2
                        ? 'label-info'
                        : index == 3
                        ? 'label-warning'
                        : index == 4
                        ? 'label-success'
                        : 'label-primary',
                    ]"
                  >
                    {{ item }}
                  </span>
                </div>
              </template>
            </el-table-column> -->
            <!-- <el-table-column prop="menuUrl" label="地址"> </el-table-column> -->
            <el-table-column prop="menuPerms" label="权限标识">
            </el-table-column>
            <el-table-column label="操作">
              <template #default="scope">
                <span
                  class="default_color pointer m-right10"
                  style="display: inline"
                  v-if="scope.row.menuType == 0"
                  @click="add(scope.row.menuId, scope.row.menuName)"
                  >添加</span
                >
                <span
                  class="default_color pointer m-right10"
                  style="display: inline"
                  v-if="scope.row.menuType != 2"
                  @click="edit(scope.row.menuId, scope.row.menuName)"
                  >编辑</span
                >
                <span
                  class="default_color pointer m-right10"
                  style="display: inline"
                  v-if="scope.row.menuType != 2"
                  @click="detail(scope.row.menuId, scope.row.menuName)"
                  >详情</span
                >

                <span
                  class="col-FF1A1A pointer"
                  style="display: inline"
                  @click="del(scope.row.menuId, scope.row.menuName)"
                  >删除</span
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="menuManagemen" v-if="isAdd">
      <Add :sendData="sendData" @closeModal="closeModal" @getData="getData" />
    </div>
    <div class="menuManagemen" v-if="isEdit">
      <Edit :sendData="sendData" @closeModal="closeModal" @getData="getData" />
    </div>
    <div class="menuManagemen" v-if="isDetail">
      <Detail
        :sendData="sendData"
        @closeModal="closeModal"
        @getData="getData"
      />
    </div>
  </div>
</template>

<script>
import {
  computed,
  defineComponent,
  reactive,
  toRefs,
  nextTick,
  onMounted,
  getCurrentInstance,
} from "vue";
import { useStore } from "vuex";
import { apiObj } from "@/config/api";
import Add from "./components/add";
import Edit from "./components/edit";
import Detail from "./components/detail";
export default defineComponent({
  components: { Add, Edit, Detail },
  name: "menuManagemen",
  setup() {
    const store = useStore();
    const { proxy } = getCurrentInstance();
    const data = reactive({
      tableId: "menuManagemenTable",
      page: 1,
      pageSize: 10,
      searchWord: "",
      totalCount: 0,
      tableData: [],
      tableHeight: 0,
      isAdd: false,
      isEdit: false,
      isDetail: false,
      sendData: null,
    });
    //获取列表数据
    const getData = async () => {
      let params = {
        searchWord: data.searchWord,
        menuClassify: "PC",
      };
      const r = await proxy.$http.get(apiObj.menuList, params);
      if (r) {
        data.tableData = composeTree(r);
      }
    };
    //构造树形
    const composeTree = (list = []) => {
      const data = JSON.parse(JSON.stringify(list)); // 浅拷贝不改变源数据
      const result = [];
      if (!Array.isArray(data)) {
        return result;
      }
      data.forEach((item) => {
        delete item.children;
      });
      const map = {};
      data.forEach((item) => {
        map[item.menuId] = item;
      });
      data.forEach((item) => {
        const parent = map[item.menuPid];
        if (parent) {
          (parent.children || (parent.children = [])).push(item);
        } else {
          result.push(item);
        }
      });
      return result;
    };
    // 添加 根目录
    const openAdd = () => {
      data.sendData = {
        menuType: 0,
        pMenuName: "根目录",
        menuPid: "-1",
        menuId: "",
      };
      data.isAdd = true;
    };
    //添加 二级菜单
    const add = (menuId, menuName) => {
      data.sendData = {
        menuType: 1,
        pMenuName: menuName,
        menuPid: menuId,
        menuId: menuId + "_",
      };
      data.isAdd = true;
    };
    // 菜单编辑
    const edit = (menuId, menuName) => {
      data.sendData = {
        menuId: menuId,
      };
      data.isEdit = true;
    };
    // 菜单详情
    const detail = (menuId, menuName) => {
      data.sendData = {
        menuId: menuId,
      };
      data.isDetail = true;
    };
    //菜单删除
    const del = (menuId, menuName) => {
      proxy
        .$confirm("您确定删除选中的数据吗", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          let params = {
            menuId: menuId,
          };
          const r = await proxy.$http.post(apiObj.menuDel, params);
          if (r.respCode == 0 || r.respCode == "0000") {
            proxy.$message.success(r.msg || r.respMsg);
            getData();
          } else {
            proxy.$message.error(r.msg || r.respMsg);
          }
        });
    };
    onMounted(() => {
      console.log(apiObj.menuList);
      nextTick(() => {
        data.tableHeight = document.querySelector(
          ".bottom_content .table_container#" + data.tableId
        ).offsetHeight;
        getData();
        console.log(data.tableHeight);
      });
      window.onresize = () => {
        nextTick(() => {
          var offsetHeight = document.querySelector(
            ".bottom_content .table_container#" + data.tableId
          ).offsetHeight;
          if (offsetHeight <= 0) {
            return false;
          }
          data.tableHeight = document.querySelector(
            ".bottom_content .table_container#" + data.tableId
          ).offsetHeight;
        });
      };
    });
    //关闭
    const closeModal = () => {
      data.isAdd = false;
      data.isEdit = false;
      data.isDetail = false;
    };
    return {
      ...toRefs(data),
      getData,
      composeTree,
      openAdd,
      closeModal,
      add,
      edit,
      detail,
      del,
    };
  },
});
</script>

<style scoped>
.menuManagemen_warp {
  width: 100%;
  height: 100%;
}
.menuManagemen {
  width: 100%;
  height: 100%;
  background: #fff;
}
/* :deep(.el-input__inner) {
  width: 280px !important;
  height: 38px !important;
  line-height: 38px !important;
} */
</style>
